import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//配置统一首页路由
var routes = [];
var routes_list = {
  jinshan: [{
      path: '/unilogin',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/login.vue`)
    },
    {
      path: '/main',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/main`)
    },

  ],
  huangdu: [{
      path: '/unilogin',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/login.vue`)
    },
    {
      path: '/main',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/main`)
    },
    {
      path: '/gdi',
      component: () =>
        import(`../_${OEM}/views/GDI_Main`)
    }, {
      path: '/lamskpi',
      component: () =>
        import(`../_${OEM}/views/a`)
    }, {
      path: '/alarmSettings',
      component: () =>
        import(`../_${OEM}/views/alarmSettings`)
    }, {
      path: '/wskpisko',
      component: () =>
        import(`../_${OEM}/views/summarizeKeyOne`)

    }, {
      path: '/wskpiskt',
      component: () =>
        import(`../_${OEM}/views/summarizeKeyTwo`)
    }
  ],
  lianhe: [{
    path: '/unilogin/:tenantId',
    meta: {
      title: "统一登录"
    },
    component: () =>
      import(`../_${OEM}/views/login/login.vue`)
  },
  {
    path: '/main',
    meta: {
      title: "统一登录"
    },
    component: () =>
      import(`../_${OEM}/views/login/main`)
  },
  {
    path: '/gdi',
    component: () =>
      import(`../_${OEM}/views/GDI_Main`)
  }, {
    path: '/lamskpi',
    component: () =>
      import(`../_${OEM}/views/a`)
  }, {
    path: '/alarmSettings',
    component: () =>
      import(`../_${OEM}/views/alarmSettings`)
  }, {
    path: '/wskpisko',
    component: () =>
      import(`../_${OEM}/views/summarizeKeyOne`)

  }, {
    path: '/wskpiskt',
    component: () =>
      import(`../_${OEM}/views/summarizeKeyTwo`)
  }
],
  yiwu: [{
      path: '/unilogin',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/login.vue`)
    },
    {
      path: '/main',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/main`)
    },
    {
      path: '/gdi',
      component: () =>
        import(`../_${OEM}/views/GDI_Main`)
    }, {
      path: '/lamskpi',
      component: () =>
        import(`../_${OEM}/views/a`)
    }, {
      path: '/alarmSettings',
      component: () =>
        import(`../_${OEM}/views/alarmSettings`)
    }, {
      path: '/wskpisko',
      component: () =>
        import(`../_${OEM}/views/summarizeKeyOne`)

    }, {
      path: '/wskpiskt',
      component: () =>
        import(`../_${OEM}/views/summarizeKeyTwo`)
    }
  ],
  yiwuBig: [{
      path: '/unilogin',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/login.vue`)
    },
    {
      path: '/main',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/main`)
    },
    {
      path: '/gdi',
      component: () =>
        import(`../_${OEM}/views/GDI_Main`)
    }, {
      path: '/lamskpi',
      component: () =>
        import(`../_${OEM}/views/a`)
    }, {
      path: '/alarmSettings',
      component: () =>
        import(`../_${OEM}/views/alarmSettings`)
    }, {
      path: '/wskpisko',
      component: () =>
        import(`../_${OEM}/views/summarizeKeyOne`)

    }, {
      path: '/wskpiskt',
      component: () =>
        import(`../_${OEM}/views/summarizeKeyTwo`)
    }
  ],
  jiading: [{
      path: '/',
      component: () =>
        import(`../_${OEM}/views/a`)
    },
    {
      path: '/gdi',
      component: () =>
        import(`../_${OEM}/views/GDI_Main`)
    }, {
      path: '/lamskpi',
      component: () =>
        import(`../_${OEM}/views/a`)
    }
  ],
  taixing: [{
      path: '/unilogin',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/login.vue`)
    },
    {
      path: '/main',
      component: () =>
        import(`../_${OEM}/views/login/main`)
    },
    {
      path: '/lamskpi',
      component: () =>
        import(`../_${OEM}/views/TaiXing`)
    },
    {
      path: '/gdi',
      component: () =>
        import(`../_${OEM}/views/GDI_Main`)
    }
  ],
  zhongshan: [{
      path: '/',
      meta: {
        title: "登录"
      },
      component: () =>
        import(`../_${OEM}/views/login.vue`)
    },
    {
      path: '/main',
      meta: {
        title: "SH3H"
      },
      component: () =>
        import(`../_${OEM}/views/main.vue`),
      children: [{
          path: '/MaintainPlan',
          meta: {
            title: "SH3H"
          },
          component: () =>
            import(`../_${OEM}/views/MaintainPlan.vue`)
        },

        {
          path: '/MessageHistoryUP',
          meta: {
            title: "SH3H"
          },
          component: () =>
            import(`../_${OEM}/views/MessageHistoryUP.vue`)
        },
        {
          path: '/Hub_Manage',
          meta: {
            title: "SH3H"
          },
          component: () =>
            import(`../_${OEM}/views/Hub_Manage.vue`)
        },
        {
          path: '/MessageHistoryDown',
          meta: {
            title: "SH3H"
          },
          component: () =>
            import(`../_${OEM}/views/MessageHistoryDown.vue`)
        },

        {
          path: '/NBarcgis',
          meta: {
            title: "SH3H"
          },
          component: () =>
            import(`../_${OEM}/views/NBArcgis.vue`),

        }, {
          path: '/iframe',
          meta: {
            title: "SH3H"
          },
          component: () =>
            import(`../_${OEM}/views/iframe.vue`),

        },
        {
          path: '/demo',
          meta: {
            title: "SH3H"
          },
          component: () =>
            import(`../_${OEM}/views/demo.vue`)
        },
        {
          path: '/demo_dtl/:id',
          meta: {
            title: "SH3H"
          },
          component: () =>
            import(`../_${OEM}/views/demo_dtl.vue`)
        },
        {
          path: '/MaintainDtl/:id',
          meta: {
            title: "SH3H"
          },
          component: () =>
            import(`../_${OEM}/views/MaintainDtl.vue`)
        },

      ]

    },
    {
      path: '/AssetsRepairDtl/:id',
      meta: {
        title: "SH3H"
      },
      component: () =>
        import(`../_${OEM}/views/AssetsRepairDtl.vue`)
    },
  ],
  chongqing: [
    {
      path: '/unilogin',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/login.vue`)
    },
    {
      path: '/main',
      meta: {
        title: "统一登录"
      },
      component: () =>
        import(`../_${OEM}/views/login/main`)
    },
  ],
  fushun: [
  //   {
  //   path: '/unilogin',
  //   meta: {
  //     title: "统一登录"
  //   },
  //   component: () =>
  //     import(`../_${OEM}/views/login/login.vue`)
  // },
  {
    path: '/',
    meta: {
      title: "统一登录"
    },
    component: () =>
      import(`../_${OEM}/views/login/main`)
  }
],
};
if (config.default_router) {
  //默认路由
  routes = [];
  routes.push({
    path: '/',
    name: 'home',
    component: () => import(`../_${OEM}/views/Home.vue`)
  });
} else {
  //配置路由
  routes = routes_list[OEM];
}

export default routes